import Vue                        from "vue";
import { mapGetters }             from "vuex"
import { 
  MyAccount, 
  LoadingSpinner, 
  DnFunctionButton 
}                                 from "@/components";
import { UserSettingsService }    from "@/services";
import { UserService }            from "@/services/UserService";
import { TourService }            from "@/services/TourService";
import { sizeHelper }             from "@/components/mixins/sizeHelper";
import {constants}           from "@/const" 
import SkeletonLoader         from "@/components/Elements/SkeletonLoader.vue";

export default Vue.extend({
  name: "UserSettings",
  components: {
    MyAccount,
    LoadingSpinner,
    DnFunctionButton,
    SkeletonLoader
  },
  mixins:[sizeHelper],
  data: () => ({
    loadingUserSettings: true,
    userCollapsePartDescriptions: false,
    userpartSearchDefaultSort: "",
    sortByOptions: constants.SORT_BY_OPTIONS,
    userGridViewDefault: false,
    userShowSideCart: false,
    savingUserSettings: false,
    userTmsCompactViewDefault: false,
    userDiagramOrientationDefault: "",
    diagramOrientationOptions: constants.DIAGRAM_ORIENTATION_OPTIONS,
    tours: [] as any[],
    loadingTours: true,
    resettingTourId: null as number | null,
  }),
  computed:{
    ...mapGetters([
      "user",
      "getContentItem",
      "userSettings",
      "collapseAllPartDescriptions",
      "partSearchDefaultSort",
      "showSideCart",
      "gridViewDefault",
      "tmsCompactViewDefault",
      "diagramOrientationDefault",
    ]),
  },
  mounted() {
    this.getUserSettings();
    this.loadTours();
  },
  methods:{
    async loadTours(){
      try {
        // An empty tour name returns all active tours.
        const response = await UserService.GetTour("", constants.DealernetClientId, true);
        this.tours = Array.isArray(response?.data) ? response.data : [];
      } catch {
        this.tours = [];
      } finally {
        this.loadingTours = false;
      }
    },
    async takeTour(tour){
      const reset = await this.resetTour(tour, !tour.TourRoute);
      if (reset && tour.TourRoute) {
        await this.$router.push("/" + String(tour.TourRoute).replace(/^\/+/, "")).catch(() => {});
        TourService.startTourWhenReady(tour.TourName || tour.Name, {
          userId: Number(this.user.UserId),
          tourId: Number(tour.TourId) || null,
        });
      }
    },
    async resetTour(tour, showMessage = true){
      this.resettingTourId = tour.TourId;
      let success = false;
      try {
        const response = await UserService.ResetUserTours(this.user.UserId, constants.DealernetClientId, [tour.TourId]);
        success = response?.data === true;
      } catch {
        success = false;
      } finally {
        this.resettingTourId = null;
      }

      if (showMessage || !success) {
        this.$store.commit("pushTimedMessage", {
          header: success ? `The "${tour.TourName || tour.Name}" tour has been reset.` : "There was a problem resetting the tour.",
          IsError: !success,
          seconds: 5,
        });
      }
      return success;
    },
    async getUserSettings(){
      this.loadingUserSettings = true;
      
      // This handles a refresh from the user settings page
      if (this.userSettings === undefined || this.userSettings.length === 0){
        await UserSettingsService.GetUserSettings(this.user.UserId)
          .then( userSettings => {
            this.$store.commit("SET_USER_SETTINGS", userSettings)
          });
      }
      this.userCollapsePartDescriptions = await this.collapseAllPartDescriptions;
      this.userpartSearchDefaultSort = await this.partSearchDefaultSort;
      this.userShowSideCart = await this.showSideCart;
      this.userGridViewDefault = await this.gridViewDefault;
      this.userTmsCompactViewDefault = await this.tmsCompactViewDefault;
      this.userDiagramOrientationDefault = await this.diagramOrientationDefault;
      this.loadingUserSettings = false;
    },
    async saveUserSettings(){    
      this.savingUserSettings = true;
      this.$store.commit("SET_COLLAPSE_ALL_PART_DESCRIPTIONS", this.collapseAllPartDescriptions.SettingValue);
      this.$store.commit("SET_PART_SEARCH_DEFAULT_SORT", this.partSearchDefaultSort.SettingValue);
      this.$store.commit("SET_GRID_VIEW_DEFAULT", this.gridViewDefault.SettingValue);
      this.$store.commit("SET_SHOW_SIDE_CART", this.userShowSideCart.SettingValue);
      this.$store.commit("SET_TMS_COMPACT_VIEW", this.tmsCompactViewDefault.SettingValue);
      this.$store.commit("SET_DIAGRAM_ORIENTATION", this.diagramOrientationDefault.SettingValue);

      let result = false;
      try{
        result = await UserSettingsService.SaveUserSettings(this.userSettings);
        if( result === true){
          this.$store.commit("SET_USER_SETTINGS", this.userSettings);
          this.$store.commit("pushTimedMessage", {
            header: "User settings saved successfully.",
            IsError: false,
            seconds: 5,
          });
        }else{
          this.$store.commit("pushTimedMessage", {
            header: "There was a problem saving user settings.",
            IsError: true,
            seconds: 5,
          });
        }
      }catch{
        this.$store.commit("pushTimedMessage", {
          header: "There was a problem saving user settings.",
          IsError: true,
          seconds: 5,
        });
      }finally{
        this.savingUserSettings = false;
      }  
    },
  }
});